
import React, { useState } from "react";
// import { Plus, Trash2 } from "lucide-react";
import toast from "react-hot-toast";
import { getSkuBySku, createFormatSku } from "../api/sku";
import { generateId } from "../utils/generateId";
import { useAuth } from "../context/AuthContext";

import { Plus, Trash2, Copy } from "lucide-react";

const createEmptyFormat = () => ({
  id: generateId(),
  baseSku: "",
  productName: "",
  formatType: "Bulk", 
  category: "Signature CA",
  netWeight: "",
  unitsPerCase: "",
  generatedSku: "",
  upc: "",
});

const gridCols = "2fr 3fr 2fr 2fr 2fr 1fr 2fr 1fr 1fr";

export default function FormatBuilder() {
  const { canWrite } = useAuth();
  const canManageCostingTool = canWrite("CostingToolPage");
  const [formats, setFormats] = useState([createEmptyFormat()]);
  const [addCount, setAddCount] = useState(1);

  const handleBaseSkuChange = async (index, value) => {
    if (!canManageCostingTool) return;
    const trimmed = value.trim().toUpperCase();
    const updated = [...formats];
    updated[index].baseSku = trimmed;
    updated[index].productName = "";
    updated[index].generatedSku = "";
    setFormats(updated);

    if (trimmed.length >= 8) {
      try {
        const data = await getSkuBySku(trimmed);
        updated[index].productName = data?.description || data?.nameEn || "";
        setFormats([...updated]);
        toast.success("Base product loaded");
      } catch (err) {
        toast.error("Base SKU not found");
      }
    }
  };

  // new function for multiple sku paste
  const handleBaseSkuPaste = (index, e) => {
  if (!canManageCostingTool) return;

  const pasteText = e.clipboardData.getData("text");
  const skus = pasteText
    .split(/[\n\r\t,]+/)
    .map((s) => s.trim().toUpperCase())
    .filter(Boolean);

  if (skus.length <= 1) return; // single value → normal onChange hi chalega

  e.preventDefault();

  const updated = [...formats];
  updated[index].baseSku = skus[0];
  updated[index].productName = "";
  updated[index].generatedSku = "";

  const newRows = skus.slice(1).map((sku) => ({
    ...createEmptyFormat(),
    baseSku: sku,
  }));

  const finalFormats = [...updated, ...newRows];
  setFormats(finalFormats);

  skus.forEach(async (sku, i) => {
    if (sku.length >= 8) {
      try {
        const data = await getSkuBySku(sku);
        setFormats((prev) => {
          const copy = [...prev];
          const targetIndex = index + i;
          if (copy[targetIndex] && copy[targetIndex].baseSku === sku) {
            copy[targetIndex].productName = data?.description || data?.nameEn || "";
          }
          return copy;
        });
      } catch (err) {
        // ignore not-found during bulk paste
      }
    }
  });

  toast.success(`${skus.length} SKUs added`);
};


const handleNetWeightPaste = (index, e) => {
  if (!canManageCostingTool) return;

  const pasteText = e.clipboardData.getData("text");
  const weights = pasteText
    .split(/[\n\r\t,]+/)
    .map((s) => s.trim())
    .filter(Boolean);

  if (weights.length <= 1) return; // single value → normal onChange hi chalega

  e.preventDefault();

  const updated = [...formats];

  weights.forEach((weight, i) => {
    const targetIndex = index + i;

    if (updated[targetIndex]) {
      // existing row hai to usi me bhar do
      updated[targetIndex].netWeight = weight;
    } else {
      // row nahi hai to nayi row bana do
      updated.push({
        ...createEmptyFormat(),
        netWeight: weight,
      });
    }
  });

  setFormats(updated);
  toast.success(`${weights.length} Net Weight values added`);
};

// const handleCopySku = (sku) => {
//   if (!sku) return;
//   navigator.clipboard.writeText(sku);
//   toast.success("SKU copied");
// };
const handleCopyAllSkus = () => {
  const allSkus = formats
    .map((f) => f.baseSku)
    .filter(Boolean);

  if (allSkus.length === 0) {
    toast.error("No SKUs to copy");
    return;
  }

  navigator.clipboard.writeText(allSkus.join("\n"));
  toast.success(`${allSkus.length} SKU(s) copied`);
};

const handleCopyAllNetWeights = () => {
  const allWeights = formats
    .map((f) => f.netWeight)
    .filter(Boolean);

  if (allWeights.length === 0) {
    toast.error("No Net Weights to copy");
    return;
  }

  navigator.clipboard.writeText(allWeights.join("\n"));
  toast.success(`${allWeights.length} Net Weight(s) copied`);
};

  const generateFormatSku = async (index) => {
    if (!canManageCostingTool) {
      toast.error("You do not have permission to generate format SKUs.");
      return;
    }
    const f = formats[index];
    if (!f.baseSku || !f.netWeight) {
      toast.error("Base SKU and Net Weight are required");
      return;
    }

    try {
      const res = await createFormatSku({
        baseSku: f.baseSku,
        netWeight: parseFloat(f.netWeight.replace(/[^0-9.]/g, "")),
        formatLabel: f.formatType,
        category: f.category,
      });

      const updated = [...formats];
      updated[index].generatedSku = res.sku || res.generatedSku;
      updated[index].upc = res.upcGenerated ? "Generated" : "";
      setFormats(updated);
      toast.success(`Format SKU created: ${updated[index].generatedSku}`);
    } catch (err) {
      const data = err?.response?.data;
      if (data?.sku || data?.existingSku) {
        toast.info("Format already exists");
        const updated = [...formats];
        updated[index].generatedSku = data.sku || data.existingSku;
        setFormats(updated);
      } else {
        toast.error(data?.error || "Failed to generate format SKU");
      }
    }
  };

  const updateFormat = (index, field, value) => {
    if (!canManageCostingTool) return;
    const updated = [...formats];
    updated[index][field] = value;
    setFormats(updated);
  };

  // const addFormat = () => {
  //   if (!canManageCostingTool) {
  //     toast.error("You do not have permission to add formats.");
  //     return;
  //   }
  //   setFormats([...formats, createEmptyFormat()]);
  // };

  const addFormat = () => {
  if (!canManageCostingTool) {
    toast.error("You do not have permission to add formats.");
    return;
  }
  const count = Math.max(1, parseInt(addCount, 10) || 1);
  const newRows = Array.from({ length: count }, () => createEmptyFormat());
  setFormats([...formats, ...newRows]);
  toast.success(`${count} row(s) added`);
};

  const removeFormat = (id) => {
    if (!canManageCostingTool) return;
    if (formats.length > 1) {
      setFormats(formats.filter((f) => f.id !== id));
    }
  };


  const handleClearAll = () => {
  if (!canManageCostingTool) {
    toast.error("You do not have permission to clear formats.");
    return;
  }
  setFormats([createEmptyFormat()]);
  toast.success("All rows cleared");
};

  return (
    <div className="space-y-6 sm:space-y-8 min-w-0 w-full max-w-full">
      <div className="bg-white rounded-2xl shadow-sm border border-gray-200 p-3 sm:p-6 md:p-8 min-w-0 w-full max-w-full overflow-hidden">
        {!canManageCostingTool && (
          <div className="mb-6 rounded-xl border border-amber-300 bg-amber-50 px-4 py-3 text-sm text-amber-800">
            Read-only mode: format create/edit/delete actions are disabled.
          </div>
        )}
        <fieldset disabled={!canManageCostingTool} className="min-w-0 w-full max-w-full border-0 p-0 m-0">
        {/* <div className="flex justify-between items-center mb-8">
          <h2 className="text-2xl font-semibold">Format Builder – Packaged Formats</h2>
          <button
            onClick={addFormat}
            className="flex items-center gap-2 px-5 py-3 bg-black text-white rounded-lg hover:bg-gray-800"
          >
            <Plus className="w-5 h-5" />
            Add Format
          </button>
        </div> */}

        <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center mb-6 sm:mb-8 gap-4">
  <h2 className="text-xl sm:text-2xl font-semibold">Format Builder – Packaged Formats</h2>
  <div className="flex flex-wrap items-center gap-2 w-full sm:w-auto">
    <button
      onClick={handleClearAll}
      className="flex items-center justify-center gap-2 px-3 sm:px-4 py-2.5 sm:py-3 border border-red-300 text-red-600 rounded-lg hover:bg-red-50 text-sm flex-1 sm:flex-none"
    >
      <Trash2 className="w-4 h-4" />
      Clear All
    </button>

    <input
      type="number"
      min="1"
      value={addCount}
      onChange={(e) => setAddCount(e.target.value)}
      className="w-16 px-3 py-2.5 sm:py-3 border rounded-lg text-center text-sm"
    />

    <button
      onClick={addFormat}
      className="flex items-center justify-center gap-2 px-4 sm:px-5 py-2.5 sm:py-3 bg-black text-white rounded-lg hover:bg-gray-800 text-sm flex-1 sm:flex-none"
    >
      <Plus className="w-5 h-5" />
      Add Line
    </button>
  </div>
</div>

        {/* Column Headers */}
        <div
          className="hidden md:grid md:grid-cols-[2fr_3fr_2fr_2fr_2fr_1fr_2fr_1fr_1fr] gap-4 mb-4 px-1 text-sm font-medium text-gray-600"
        >
          {/* <div>Base SKU</div> */}
          <div className="flex items-center gap-1">
  Base SKU
  <button
    type="button"
    onClick={handleCopyAllSkus}
    title="Copy all Base SKUs"
  >
    <Copy className="w-3.5 h-3.5" />
  </button>
</div>
          <div>Description</div>
          <div>Format Type</div>
          <div>Category</div>
          {/* <div>Net Weight</div> */}
          <div className="flex items-center gap-1">
  Net Weight
  <button
    type="button"
    onClick={handleCopyAllNetWeights}
    title="Copy all Net Weights"
  >
    <Copy className="w-3.5 h-3.5" />
  </button>
</div>
          <div>Units/Case</div>
          <div>Generated SKU</div>
          <div className="text-center">Generate</div>
          <div className="text-center">Action</div>
        </div>

        <div className="space-y-6">
          {formats.map((f, index) => (
            <div
              key={f.id}
              className="grid grid-cols-1 md:grid-cols-[2fr_3fr_2fr_2fr_2fr_1fr_2fr_1fr_1fr] gap-4 items-center p-4 sm:p-6 border border-gray-200 rounded-xl bg-gray-50 md:bg-transparent"
            >
              {/* Base SKU */}
              {/* <div>
                <label className="md:hidden text-xs font-medium text-gray-600">Base SKU</label>
                <input
                  placeholder="e.g. 1032610001"
                  className="w-full px-4 py-3 border rounded-lg font-mono text-sm"
                  value={f.baseSku}
                  onChange={(e) => handleBaseSkuChange(index, e.target.value)}
                />
              </div> */}

              <div>
  <label className="md:hidden text-xs font-medium text-gray-600">Base SKU</label>
  <div style={{ position: "relative" }}>
    <input
      placeholder="e.g. 1032610001"
      className="w-full px-4 py-3 border rounded-lg font-mono text-sm"
      value={f.baseSku}
      onChange={(e) => handleBaseSkuChange(index, e.target.value)}
      onPaste={(e) => handleBaseSkuPaste(index, e)}
    />
    {f.baseSku && (
      <button
        type="button"
        onClick={() => handleCopyAllSkus(f.baseSku)}
        title="Copy SKU"
        style={{
          position: "absolute",
          right: "8px",
          top: "50%",
          transform: "translateY(-50%)",
        }}
      >
        {/* <Copy className="w-4 h-4" /> */}
      </button>
    )}
  </div>
</div>



              {/* Description */}
              <div>
                <label className="md:hidden text-xs font-medium text-gray-600">Description</label>
                <input
                  className="w-full px-4 py-3 border rounded-lg bg-gray-100 text-sm"
                  value={f.productName}
                  readOnly
                />
              </div>

              {/* Format Type */}
              <div>
                <label className="md:hidden text-xs font-medium text-gray-600">Format Type</label>
                <select
                  className="w-full px-4 py-3 border rounded-lg"
                  value={f.formatType}
                  onChange={(e) => updateFormat(index, "formatType", e.target.value)}
                >
                  <option>Bulk</option>
                  <option>Pouch</option>
                  <option>Glass Jar</option>
                  <option>Bag</option>
                </select>
              </div>

              {/* Category */}
              <div>
                <label className="md:hidden text-xs font-medium text-gray-600">Category</label>
                <select
                  className="w-full px-4 py-3 border rounded-lg"
                  value={f.category}
                  onChange={(e) => updateFormat(index, "category", e.target.value)}
                >
                  <option>Signature CA</option>
                  <option>Signature US</option>
                  <option>Signature MX</option>
                  <option>Custom</option>
                </select>
              </div>

              {/* Net Weight */}
              {/* <div>
                <label className="md:hidden text-xs font-medium text-gray-600">Net Weight</label>
                <input
                  placeholder="2.5kg or 2500g"
                  className="w-full px-4 py-3 border rounded-lg text-sm"
                  value={f.netWeight}
                  onChange={(e) => updateFormat(index, "netWeight", e.target.value)}
                  onPaste={(e) => handleNetWeightPaste(index, e)}
                />
              </div> */}

              <div>
  <label className="md:hidden text-xs font-medium text-gray-600">Net Weight</label>
  <div style={{ position: "relative" }}>
    <input
      placeholder="2.5kg or 2500g"
      className="w-full px-4 py-3 border rounded-lg text-sm"
      value={f.netWeight}
      onChange={(e) => updateFormat(index, "netWeight", e.target.value)}
      onPaste={(e) => handleNetWeightPaste(index, e)}
      style={{ paddingRight: "32px" }}
    />
    {f.netWeight && (
      <button
        type="button"
        title="Copy Net Weight"
        style={{
          position: "absolute",
          right: "8px",
          top: "50%",
          transform: "translateY(-50%)",
        }}
      >
      </button>
    )}
  </div>
</div>

              {/* Units per Case */}
              <div>
                <label className="md:hidden text-xs font-medium text-gray-600">Units/Case</label>
                <input
                  type="number"
                  className="w-full px-4 py-3 border rounded-lg text-center"
                  value={f.unitsPerCase}
                  onChange={(e) => updateFormat(index, "unitsPerCase", e.target.value)}
                />
              </div>

              {/* Generated SKU */}
              <div>
                <label className="md:hidden text-xs font-medium text-gray-600">Generated SKU</label>
                <input
                  className="w-full px-4 py-3 border rounded-lg bg-gray-100 font-mono text-sm"
                  value={f.generatedSku || "Not generated"}
                  readOnly
                />
              </div>

              {/* Generate Button */}
              <div className="text-center">
                <button
                  onClick={() => generateFormatSku(index)}
                  className="w-full md:w-auto px-6 py-3 whitespace-nowrap bg-black text-white rounded-lg hover:bg-gray-800 text-sm"
                >
                  Generate SKU
                </button>
              </div>

              {/* Remove */}
              <div className="text-center">
                <button
                  onClick={() => removeFormat(f.id)}
                  disabled={formats.length === 1}
                  className={`p-2 rounded-lg transition ${
                    formats.length === 1
                      ? "text-gray-300 cursor-not-allowed"
                      : "text-red-600 hover:bg-red-50"
                  }`}
                >
                  <Trash2 className="w-5 h-5" />
                </button>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-8 text-sm text-gray-600">
          <p>• Enter existing raw material SKU (e.g. oregano ground)</p>
          <p>• Select format and net weight → system auto-generates packaged SKU, title, UPC, and BOM with packaging items</p>
        </div>
        </fieldset>
      </div>
    </div>
  );
}
